<template>
    <div>
        <div class="tiankeng">
            <h1>“天坑”续集：自动化变形监测再升级！</h1>
            <div class="tkproject">
            <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>背景介绍</h6>
           </div>
           <p>随着《“十三五”资源领域科技创新专项规划》的提出，智慧矿山一词在矿山领域所谓随处可见，而智慧矿山的提出，首要是矿山的数字化与信息化建设；安全、高效、清洁是<br>智慧矿山的本质；推动传统行业的转型升级，应充分利用现代通信、传感、信息与通讯技术，实现矿山生产过程的自动检测、智能监测、智能控制与智慧调度。</p>
           <img src="../../assets/tiankeng/1.jpg" alt="">
                <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>监测点介绍</h6>
           </div>
           <p>2010年2月22日，黄石国家矿山公园被评为国家AAAA级景区。黄石国家矿山公园拥有亚洲最大的硬岩复垦基地。“矿冶大峡谷”为黄石国家矿山公园核心景观，形如一只硕大的<br>倒葫芦，东西长2200米、南北宽550米、最大落差444米、坑口面积达108万平方米，被誉为“亚洲第一天坑”。2018年1月，入选第一批中国工业遗产保护名录。最近又有好消<br>息传来，香港某大亨多次造访矿山公园，拟打造世界级电影旅游基地。</p>
           <img src="../../assets/tiankeng/2.jpg" alt="">
           <img src="../../assets/tiankeng/3.jpg" alt="">
           <img src="../../assets/tiankeng/4.jpg" alt="">
           <p>“亚洲第一天坑”内的地质构造复杂，部分坡体目前正处在变形发展阶段，局部已完全破坏。《金属非金属矿山安全规程》（GB 16423-2006）规定：露天开采转为地下开采的，<br>边坡高度高于200米的，未对边坡采取在线监测措施；露采边坡地下转露天开采，未探明采空区的，或者未对采空区实施专项安全技术措施的，即为重大生产安全事故隐患。我们<br>在天坑选定7个监测点，对坑体主要断裂裂隙构造发育处进行重点监护。</p>
            <img src="../../assets/tiankeng/5.jpg" alt="">
            <p>洪山溪尾矿库是矿山选矿厂排废的堆积场，其主要构筑物是尾矿坝，随着选厂排废数量的增加，尾矿坝也不断升高。形成的尾矿砂堆积体。尾矿坝的工程地质特性、在使用过程<br>中对尾矿库实行科学管理的程度，关系到尾矿坝的安全稳定性、选厂能否维持正常生产以及下游居民、企业的生命、财产的安全。我们在尾矿坝设定3处监测点，实时采集监测<br>点位移数据。</p>
             <img src="../../assets/tiankeng/6.jpg" alt="">
                    <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>监测点施工难点</h6>
           </div>
           <p>据说还有考试，好激动！</p>
           <p>第一天，我们技术人员接受了大冶铁矿安监科的安全教育培训，好激动，好久没有参加考试了，最后，顺利拿到了上岗证。但是，到了施工现场，就没有想象中的那么美好了，<br>施工现场没有水，没有电，甚至没有路，更有甚者有些地方还有可怕的野猪出没，就问你怕不怕！</p>
           <p>于是，我们决定这样......</p>
             <img src="../../assets/tiankeng/7.jpg" alt="">
             <img src="../../assets/tiankeng/8.jpg" alt="">
                <img src="../../assets/tiankeng/9.jpg" alt="">
             <img src="../../assets/tiankeng/10.jpg" alt="">
                           <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>监测施工与数采方案</h6>
           </div>
           <p>这些实施难题都被我们克服了，取得目标成果自然不在话下。经过现场踏勘及与甲方沟通后，确立了基础设计方案，太阳能板由四根高1m的钢筋混凝土立柱支撑，四根立<br>柱作地基，主筋与配筋均按照土建标准进行设计与施工。高陡边坡由于均为岩石或碎石子，固定太阳能板最为合适，故开挖沟槽，把太阳能板放入，浇筑混凝土。</p>

               <img src="../../assets/tiankeng/11.jpg" alt="">
                <img src="../../assets/tiankeng/12.jpg" alt="">
            <p>本次自动化监测项目，主要由室外实时采集系统完成数据采集任务。我们采用岩石云自动化监测平台进行数据处理、分析、预警等工作。项目设备由太阳能板、蓄电池、<br>设备机箱、RT-2000-GS监测终端等组成。数据通过RT-2000-GS监测终端内置4G通讯模组与RocMoS自动化监测软件连接，组成一体化监测系统。</p>
              <img src="../../assets/tiankeng/13.jpg" alt="">
              <p>在我们RocMoS自动化监测软件界面，可以对监测项目进行在线网络化管理，在服务器或者在手机客户端对项目进展进行数据评估与预估值报警设置等。</p>
               <img src="../../assets/tiankeng/14.jpg" alt="">
            <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>监测成果展示</h6>
           </div>
           <p>通过数据传输线的连接，太阳能板的充电量以及温度、负载信息等实时数据我们就能在RocMoS监测软件上面一目了然。</p>
             <img src="../../assets/tiankeng/15.jpg" alt="">
             <p>最重要的就是卫星数据的解算！但是对RocMoS来说 so easy！</p>
             <p>RocMoS系统具有如下特点：</p>
             <p>* 支持多星系统接收机监测</p>
             <p>*  观测站间无需通视，点位选择更加灵活</p>
             <p>*  观测误差不积累，各监测点观测精度分布均匀</p>
             <p>*  操作简便，无需进行手工重复劳动</p>
             <p>*  定位精度高，实时性强</p>
             <p>*  全天候作业，真正实现连续实时观测，特别适合变形监测和高频动态监测</p>
             <p>*  可直接提供三维坐标及其绝对变化量，没有量程限制</p>
             <p>*  自动化程度高，可以完全实现远程监测，远程控制、远程下载数据，方便实现信息发布</p>
             <p>*  多级预警设置</p>
              <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>项目总结</h6>
           </div>
           <p>本项目的顺利完成离不开大冶铁矿相关技术同志的密切配合，同时也是岩石科技自主研发RocMoS网络一体化自动监测系统又一次踏上国家森林公园，给矿山边坡及尾矿坝<br>自动化在线监测预警平台增加一种技术方案以及数据采集与管理平台。</p>



            </div>




        </div>
     <foot></foot>
    </div>
</template>

<style>
.tiankeng {
  width: 100%;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
}
.tiankeng .tkproject {
  width: 11.2rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-bottom: 0.27rem;
  margin-bottom: 0.67rem;
}
.tiankeng h1 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
  text-align: center;
}
.tiankeng .tkproject p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-top: 0.1rem;
}
.tkproject .basic_title {
  margin-top: 0.34rem;
  margin-bottom: 0.04rem;
}
.tkproject .axis {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
.tkproject h6 {
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(37, 43, 58, 1);
}
.tkproject img {
  margin-top: 0.2rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>


// WEBPACK FOOTER //
// src/homepages/casepage/tiankeng.vue